(function( $ ) {
	'use strict';

	// Start things up
	go_under_search.init = function() {
		this.search_reset_debounce = null;
		
		// Grab the search wrapper
		this.$search_wrapper  = $( '.search-results-wrapper' );
		
		// Stop immediately if the search wrapper isn't there
		if ( 0 == this.$search_wrapper.length ) {
			return;
		}

		// Get what we need for properly displaying the search results
		this.$load_more       = this.$search_wrapper.find( '.load-more' );
		this.$results_div     = this.$search_wrapper.find( '.results' );
		this.$rec_results_div = this.$search_wrapper.find( '.recent-results' );
		this.$error_div       = this.$search_wrapper.find( '.error' );

		// Get the search form, search field and sort control
		this.$search_form  = $( '.search .keyword form' );
		this.$search_field = this.$search_form.find( '.search-field' );
		this.$sort_by      = $( '#search-sort-by' );

		// Get the filters
		this.$domains        = $( '.domain-filters' );
		this.$filters        = $( '.search-filters' );

		// Get the fitlers button and the filter side bar
		this.$filters_button = $( '.filters-button a' );
		this.$sidebar        = $('.search-filters-sidebar');
		
		// Get initial values for the search parameters as reflected in the controls
		this.post_authors = this.get_filter_values( 'analyst' );
		this.go_types     = this.get_filter_values( 'product' );
		this.topics       = this.get_filter_values( 'topic' );
		this.roles        = this.get_filter_values( 'roles' );
		this.domains      = this.get_domain_values();
		this.sort         = this.$sort_by.val();
		this.sort_chosen  = 'no';

		// Get all filter search inputs
		this.$filter_search = $( '.filter-search-container input[type="text"]' );

		// Get stuff we need for the search history
		this.search_history_template = Handlebars.compile( $( '#go-under-search-history-template' ).html() );
		this.$search_history = this.get_search_history();

		// Start up the handlers
		this.handle_search_form();
		this.handle_filters();
		this.handle_filters_button();
		this.handle_sort();

		this.handle_filters_search();
		this.handle_load_more_button();
		this.handle_clear_filters_button();
		
		this.resize_actions();
		
		// Watch for resize:debounce and trigger debounce actions
		$('body').on( 'resize:debounce', function( event ) {
			go_under_search.resize_actions();
		});
		
		// If auto_search is true go ahead an immediately run a search
		if ( this.auto_search ) {
			this.do_search();
		}
	};

	// Watch for clicks to the clear filters button and act accordingly
	go_under_search.handle_clear_filters_button = function() {
		this.$filters.find( '.clear-filters' ).on( 'click', function( event ) {
			event.preventDefault();
			
			if ( ! $(this).hasClass( 'active' ) ) {
				return;
			}
			
			go_under_search.clear_filters();
		});
		
		if ( this.filters_active() ) {
			this.$filters.find( '.clear-filters' ).addClass( 'active' );
		}
	};
	
	// Return true if there are filters active
	go_under_search.filters_active = function() {
		return this.$filters.find( 'input[type="checkbox"]:checked' ).length;
	};
	
	// Clear out the selected filters
	go_under_search.clear_filters = function() {
		this.$filters.find( 'input[type="checkbox"]:checked' ).click();
	};

	// Allow for searching inside of a filter for larger filter lists
	go_under_search.handle_filters_search = function() {
		// Find the last item and give it a specific class so it's convenient to style it differently
		this.$filter_search.closest( '.search-filter' ).find( '.search-item:visible' ).last().addClass('last');
		
		// Watch for anyone tring to search inside of a filter search field
		this.$filter_search.on( 'keyup', function( event ) {
			let $search_filters = $(this).closest( '.search-filter' ).find( '.search-item' );
			let $cancel_button = $(this).closest( '.filter-search-container' ).find( '.cancel' );
			let search_term = $(this).val().toLowerCase();
				
			$search_filters.removeClass( 'last' );
						
			if ( '' == search_term ) {
				// There's no search term so we just reset the list
				$search_filters.removeClass( 'd-none' );
				$cancel_button.addClass( 'd-none' );
			} else {
				// Show the cancel button
				$cancel_button.removeClass( 'd-none' );
				
				// Cycle through the list and hide items that don't contain the search term
				$.each( $search_filters, function( key, item ){
					let search_filter = $(item).data( 'search-filter' ).toLowerCase();
					
					if ( search_filter.includes( search_term ) ) {
						$(item).removeClass( 'd-none' );
					} else {
						$(item).addClass( 'd-none' );
					}
				});
			}
			
			// Re-add the .last class
			$(this).closest( '.search-filter' ).find( '.search-item:visible' ).last().addClass('last');
		});
		
		// Watch for clicks to the cancel search button
		this.$filter_search.closest( '.filter-search-container' ).find( '.cancel' ).on( 'click', function( event ) {
			event.preventDefault();
			
			$(this).closest( '.filter-search-container' ).find( 'input[type="text"]' ).val( '' ).trigger( 'keyup' );
		});
	};

	// Handle filter functionality when in the mobile view
	go_under_search.handle_filters_button = function() {
		// Display the filters when someone clicks the filter button
		this.$filters_button.on( 'click', function(event) {
			event.preventDefault();
			
			go_under_search.$sidebar.toggleClass('active' );
			
			// Move vew up to the top even if the user previous scrolled inside the filters list
		    $('.search-filters-sidebar').animate({
		        scrollTop: $('.search-filters-sidebar h5')
		    }, 1);
		});
		
		// close the filters list when someone clicks on the see results button
		this.$sidebar.find( '.see-results' ).on( 'click', function(event) {
			event.preventDefault();
			
			go_under_search.$sidebar.css( 'padding-top', 0);
			go_under_search.$sidebar.toggleClass('active' );
			
		    $('html, body').animate({
		        scrollTop: $('body')
		    }, 500);
		});
	};

	// Handle interaction with the serach form and search history
	go_under_search.handle_search_form = function() {
		// Add a class if the search field contains something
		this.ready_not_ready();

		this.$search_field.on( 'input', function() {
			go_under_search.ready_not_ready();
		});
		
		// Show search history when search field is focused
		this.$search_field.on( 'focus', function() {
			let search_history = go_under_search.get_search_history();
			
			if ( 0 == search_history.length ) {
				return;
			}
			
			let search_history_div = go_under_search.search_history_template( {'search_history': search_history });
			
			// Remove any existing search history divs
			$( '#go-under-search-history' ).remove();
			
			// Append the search history to the form
			$(this).closest( 'form' ).append( search_history_div );
		});

		// Watch for clicks to search history
		$(document).on( 'click', '#go-under-search-history a', function(event) {
			event.preventDefault();

			// Set the search keyword and do a search
			let keywords = $(this).data('keywords');

			// Remove the search history div
			$( '#go-under-search-history' ).remove();
			
			go_under_search.$search_field.val( keywords );
			go_under_search.$search_form.submit();
		});
		
		// Remove search history on focusout unless we clicked inside the search history
		$(document).on( 'click', function( event ) {
			if ( 
				! $.contains( $('#go-under-search-history'), event.target )
				&& ! go_under_search.$search_field.is(':focus')
			) {
				$( '#go-under-search-history' ).remove();
			}
		});

		this.$search_form.on( 'submit', function( event ) {
			event.preventDefault();
							
			let search_term = $(this).find('.search-field').val();
			
			go_under_search.trigger_event( $(this).find('.search-field') );
			
			go_under_search.$search_field.val( search_term );
			
			go_under_search.keyword = go_under_search.$search_field.val();
			go_under_search.reset_results();
			go_under_search.do_search();
		});
	};

	// Add remove a ready class to the search field based on whether it has a value or not
	go_under_search.ready_not_ready = function() {
		if ( '' !== this.$search_field.val() ) {
			this.$search_form.addClass( 'ready' );
		} else {
			this.$search_form.removeClass( 'ready' );
		}
	};
	
	// Watch for changes to the sort setting
	go_under_search.handle_sort = function() {
		this.$sort_by.on( 'change', function( event ) {
			go_under_search.sort_chosen = 'yes';
			go_under_search.sort        = go_under_search.$sort_by.val();
			
			go_under_search.trigger_event( go_under_search.$sort_by );
			
			go_under_search.do_search_reset();
		});
	};

	// Watch for updates to the filters and domain buttons and run a search when changes occur
	go_under_search.handle_filters = function() {		
		this.$filters.find('input[name="analyst[]"]').on( 'change', function() {
			go_under_search.post_authors = go_under_search.get_filter_values( 'analyst' );
			
			go_under_search.trigger_event( $(this) );
			
			go_under_search.do_search_reset();
		});

		this.$filters.find('input[name="product[]"]').on( 'change', function() {
			go_under_search.go_types = go_under_search.get_filter_values( 'product' );
			
			go_under_search.trigger_event( $(this) );
			
			go_under_search.do_search_reset();
		});
		
		this.$filters.find('input[name="topic[]"]').on( 'change', function() {
			go_under_search.topics = go_under_search.get_filter_values( 'topic' );
			
			go_under_search.trigger_event( $(this) );
			
			go_under_search.do_search_reset();
		});
		
		this.$filters.find('input[name="role[]"]').on( 'change', function() {
			go_under_search.roles = go_under_search.get_filter_values( 'role' );
			
			go_under_search.trigger_event( $(this) );
			
			go_under_search.do_search_reset();
		});
		
		this.$filters.find('input[name="domain[]"]').on( 'change', function() {			
			go_under_search.domains = go_under_search.get_filter_values( 'domain' );
			go_under_search.sync_domain_controls( 'checkboxes' );
			
			go_under_search.trigger_event( $(this) );
			
			go_under_search.do_search_reset();
		});
		
		this.$domains.find('.domain-filter').on( 'click', function(event) {
			event.preventDefault();
			
			$(this).toggleClass( 'domain-active');
			
			go_under_search.sync_domain_controls( 'buttons' );

			go_under_search.trigger_event( $( '#domain-' + $(this).data( 'term-id' ) ) );

			go_under_search.domains = go_under_search.get_filter_values( 'domain' );
			go_under_search.do_search_reset();
		});
	};
	
	// Sync the domain filter values with the domain buttons and vice versa
	go_under_search.sync_domain_controls = function( from = 'buttons' ) {
		if ( 'buttons' == from ) {
			var $field = this.$domains.find('.domain-filter');

			$field.each(function( key ) {
				if ( $(this).hasClass( 'domain-active' ) ) {
					$( '#domain-' + $(this).data( 'term-id' ) ).prop( 'checked', true );
				} else {
					$( '#domain-' + $(this).data( 'term-id' ) ).prop( 'checked', false );
				}
			});
		} else {
			var $field = this.$filters.find('input[name="domain[]"]');

			$field.each(function( key ) {
				if ( $(this).is( ':checked' ) ) {
					$( '#domain-' + $(this).data( 'slug' ) ).addClass( 'domain-active' );
				} else {
					$( '#domain-' + $(this).data( 'slug' ) ).removeClass( 'domain-active' );
				}
			});
		}
		
		this.$domains.trigger({ type: 'go_search_sync_domains' });
	}

	// Get the current filter values for a given filter
	go_under_search.get_filter_values = function( field ) {
		var $field = this.$filters.find('input[name="' + field + '[]"]:checked');

		var values = [];

		$field.each(function( key ) {
			values[key] = $(this).val();
		});

		return values.join( ',' );
	};
	
	// Get the current filter slugs for a given filter
	go_under_search.get_filter_slugs = function( field ) {
		var $field = this.$filters.find('input[name="' + field + '[]"]:checked');

		var slugs = [];

		$field.each(function( key ) {
			slugs[key] = $(this).data( 'slug' );
		});

		return slugs;
	};
	
	// Get the current domain button values
	go_under_search.get_domain_values = function( field ) {
		var $field = this.$domains.find('.domain-active');

		var values = [];

		$field.each(function( key ) {
			values[key] = $(this).data('search-value');
		});

		return values.join( ',' );
	};

	// Do a debounced search reset and search
	go_under_search.do_search_reset = function() {
		clearTimeout( this.search_reset_debounce );

		this.search_reset_debounce = setTimeout(function() {
			go_under_search.reset_results();
			go_under_search.do_search();
		}, 1337 );
	};

	// Do a date based search and get only 3 results and return them to the top of the results list
	go_under_search.do_recent_search_ajax = function( $data ) {
		$data.size = 3;
		$data.sort_field = 'post_date_gmt';
		$data.sort_chosen = 'yes';
					
		$.ajax({
			url: this.ajax_url,
			type: 'get',
			dataType: 'json',
			data: $data,
			complete : function() {
				// Don't need this unless we're debugging
				//console.log('recent:');
				//console.log(this.url);
			},
			success: function (result) {
				//console.log(result);
				if ( result.data.found > 0 ) {
					// Append search results
					go_under_search.$rec_results_div.append( result.data.items );

					// Do resize actions
					$( 'body' ).trigger('resize:debounce');

					// Update the $data stuff so we can pass it to the regular search function
					$data.size = go_under_search.size;
					$data.sort_field = go_under_search.sort;
					$data.sort_chosen = go_under_search.sort_chosen;
					
					// Exclude the stuff we found from the next search
					let excluded_ids = [];
					
					go_under_search.$rec_results_div.find( 'article' ).each(function( key, element ) {
						excluded_ids.push( $(element).data('post-id') );
					});
					
					$data.excluded_ids = excluded_ids.join( ',' );

					// Run the regular search
					go_under_search.do_search_ajax( $data );
				} else {
					// No results found
					go_under_search.show_error( result.data.message );
					
					// Hide loader
					go_under_search.hide_loader();
					go_under_search.hide_load_more();
					
					// Enable the form again
					go_under_search.enable_form();
				}
			}
		});
	};
	
	// Do the ordinary search
	go_under_search.do_search_ajax = function( $data ) {
		$.ajax({
			url: this.ajax_url,
			type: 'get',
			dataType: 'json',
			data: $data,
			complete : function() {
				// Don't need this unless we're debugging
				//console.log('regular:');
				//console.log(this.url);
			},
			success: function (result) {
				//console.log(result)
				// Update start point
				go_under_search.start = result.data.start;

				// Hide loader
				go_under_search.hide_loader();

				// If there are no more result hide the Load More button
				if ( ! result.data.load_more ) {
					go_under_search.hide_load_more();
				}

				if ( result.data.found > 0 ) {
					// Append search results
					go_under_search.$results_div.append( result.data.items );
					
					// Do resize actions
					$( 'body' ).trigger('resize:debounce');
				} else if ( go_under_search.$rec_results_div.is(':empty') ) {
					// No results found
					go_under_search.show_error( result.data.message );
				}

				// Check for topic banners we should show
				let $topic_slugs = go_under_search.get_filter_slugs( 'topic' );

				if ( 1 === $topic_slugs.length && 0 !== $( '#topic-banner-' + $topic_slugs[0] ).length ) {
					$( '#topic-banner-' + $topic_slugs[0] ).removeClass( 'd-none' );
				}

				// Enable the form again
				go_under_search.enable_form();
			}
		});
	};

	go_under_search.do_search = function() {
		// Hide topic banners
		$( '.topic-banner' ).addClass( 'd-none' );
		
		$( '.archive-wrapper' ).addClass( 'd-none' );
		this.$search_wrapper.removeClass( 'd-none' );
		
		this.show_loader();
		this.disable_form();

		this.keyword = this.$search_field.val();

		if ( '' != this.keyword ) {
			this.update_search_history( this.keyword );
		}

		if ( '' == this.sort ) {
			this.sort = 'post_date_gmt';
		}

		if ( '' != this.keyword ) {
			this.keyword = '"' + this.keyword + '"';
		}
		
		// This is a hack but they want sorting to work differently for the zero-trust stuff
		let $topic_slugs = this.get_filter_slugs( 'topic' );
		let sort_order   = this.order;
				
		if ( 
			   0 == this.domains.length
			&& 0 == this.go_types.length
			&& 0 == this.post_authors.length
			&& 0 == this.roles.length
			&& 1 == $topic_slugs.length
			&& 'zero-trust' == $topic_slugs[0]
		) {
			sort_order = 'asc';
		}

		// Build search data
		let $data = {
			action: 'acs_search_documents',
			//action: 'acs_search_documents_full',
			keyword: this.keyword,
			start: this.start,
			size: this.size,
			type_field: this.type,
			sort_field: this.sort,
			sort_order: sort_order,
			post_authors: this.post_authors,
			go_types: this.go_types,
			domains: this.domains,
			topics: this.topics,
			roles: this.roles,
			sort_chosen: this.sort_chosen
		};

		// If we haven't already done it do a more limited date based search first
		if ( '' != this.keyword && this.$rec_results_div.is(':empty') && 'no' == this.sort_chosen ) {
			this.do_recent_search_ajax( $data );
		} else {
			this.do_search_ajax( $data );
		}
	};

	// Handle clicks to the load more button
	go_under_search.handle_load_more_button = function() {
		this.$load_more.on( 'click', function( event ) {
			event.preventDefault();

			if ( $(this).hasClass( 'loading' ) ) {
				return;
			} else {
				go_under_search.do_search();
			}
		});
	};

	// Reset the search results to prep for a new search
	go_under_search.reset_results = function() {
		this.start = 0;
		this.hide_error();
		this.$rec_results_div.empty();
		this.$results_div.empty();
	};

	// Disable the search form and other interface elements
	go_under_search.disable_form = function() {
		this.$search_form.find( 'input, select' ).prop( 'disabled', true );
		this.$sort_by.prop( 'disabled', true );
		this.$filters.find( 'input, select' ).prop( 'disabled', true );
		this.$filters.find( '.clear-filters' ).addClass( 'disabled' );
		this.$domains.find( 'a' ).addClass( 'disabled' );
	};

	// Enable the search form and other interface elements
	go_under_search.enable_form = function() {
		if ( this.filters_active() ) {
			this.$filters.find( '.clear-filters' ).addClass( 'active' );
		} else {
			this.$filters.find( '.clear-filters' ).removeClass( 'active' );
		}
		
		this.$filters.find( '.clear-filters' ).removeClass( 'disabled' );
		this.$search_form.find( 'input, select' ).prop( 'disabled', false );
		this.$sort_by.prop( 'disabled', false );
		this.$filters.find( 'input, select' ).prop( 'disabled', false );
		this.$domains.find( 'a' ).removeClass( 'disabled' );
	};

	// Show the research loading element
	go_under_search.show_loader = function() {
		this.$load_more.removeClass( 'd-none' );
		this.$load_more.addClass( 'loading' );
	};

	// Hide the research loading element
	go_under_search.hide_loader = function() {
		this.$load_more.removeClass( 'loading' );
	};

	// Hide the load more button
	go_under_search.hide_load_more = function() {
		this.$load_more.addClass( 'd-none' );
	};

	// Show the error element
	go_under_search.show_error = function( message ) {
		if ( 'No results' == message ) {
			message = '<strong>No results!</strong> No research was found matching your criteria.';
		}
		
		this.$error_div.html( message );
		this.$error_div.removeClass( 'd-none' );
	};

	// Hide the error element
	go_under_search.hide_error = function() {
		this.$error_div.addClass( 'd-none' );
	};

	// Clear the user's search history
	go_under_search.clear_search_history = function() {		
		this.set_cookie( 'go_under_search_history', JSON.stringify( [] ), 36500 );

		return search_history;
	};

	// Update the user's search history
	go_under_search.update_search_history = function( keyword ) {
		keyword = keyword.trim();
		
		if ( '' == keyword ) {
			return;
		}
		
		let search_history = this.get_search_history();
		
		if ( search_history.includes( keyword ) ) {
			let index = search_history.indexOf( keyword );
			search_history.splice( index, 1 );
		}
		
		search_history.unshift( keyword );

		// Limit history to 10 items
		if ( 10 < search_history.length ) {
			search_history.length = 10;
		}
		
		this.set_cookie( 'go_under_search_history', JSON.stringify( search_history ), 36500 );

		return search_history;
	};
	
	// Retrieve the user's search history if it exists
	go_under_search.get_search_history = function() {
		let search_history = this.get_cookie( 'go_under_search_history' );
		
		if ( '' == search_history  ) {
			search_history = [];
		} else {
			search_history = JSON.parse( search_history );
		}

		return search_history;
	};
	
	// Get cookie helper function
	go_under_search.get_cookie = function( name ) {
		return document.cookie.match( '(^|;)\\s*' + name + '\\s*=\\s*([^;]+)' )?.pop() || '';
	};
	
	// Set cookie helper function
	go_under_search.set_cookie = function( cookie_name, cookie_value, days ) {
		// 36500 days is 100 years
		const d = new Date();
		d.setTime(d.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
		let expires = d.toUTCString();
		
		document.cookie = cookie_name + '=' + cookie_value + '; expires=' + expires +'; path=/';
	};
	
	// Stuff to do when the 'resize:debounce' event triggers
	go_under_search.resize_actions = function() {
		let header_offset = 0;
		
		if ( 768 >= $(window).width() ) {
			header_offset = go_under.$header.height() - 2;
		
			if ( go_under.$wpadminbar.length ) {
				header_offset = header_offset + go_under.$wpadminbar.height() - 1;
			}
		}
		
		go_under_search.$sidebar.css( 'margin-top', header_offset + 'px' );
		go_under_search.$sidebar.css( 'padding-bottom', header_offset + 'px' );
	};
	
	// Trigger a Google Tag Manager event
	go_under_search.trigger_event = function( $element ) {
		if ( 'undefined' == typeof dataLayer ) {
			return;
		}

		let event_args = {
			'event': 'search_filter_selected',
			'filter': $element.data( 'filter' ),
			'value': $element.data( 'slug' )
		};
		
		if ( 'search-sort-by' == $element.attr( 'id' ) ) {
			event_args = {
				'event': 'search_sorting_changed',
				'sort': $element.val()
			};
		} else if ( $element.hasClass( 'search-field' ) ) {
			event_args = {
				'event': 'keyword_search',
				'keyword': $element.val()
			};
		} else if ( $element.hasClass( 'search-filter-input' ) ) {
			// Don't record filter changes if the filter is inactive
			if ( ! $element.is( ':checked' ) ) {
				return;
			}
		}
		
		dataLayer.push( event_args );
	};

	$( function() {
		go_under_search.init();
	} );
})( jQuery );